import { axiosAPIInstance as axios } from '../../axios-config';

const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
  async createCoupon(_, coupon) {
    const response = await axios.post('braintree/coupons', coupon);
    return response.data;
  },
  async generateCoupons(_, coupon) {
    const response = await axios.post('braintree/bulkcoupons', coupon);
    return response.data;
  },
  async getCoupon(_, { couponId }) {
    const response = await axios.get(`braintree/coupons/${couponId}`);
    return response.data;
  },
  async getCoupons() {
    const response = await axios.get('braintree/coupons');
    return response.data.coupons;
  },
  async updateCoupon(_, coupon) {
    const response = await axios.patch(`braintree/coupons/${coupon._id}`, coupon);
    return response.data;
  },
  async deleteCoupon(_, { couponId, _id }) {
    const did = couponId || _id;
    const response = await axios.delete(`braintree/coupons/${did}`);
    return response.data;
  }
};

export default {
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/braintree/coupons.js